import { useEffect, useState } from "react";
import { Carousel } from "flowbite-react";
import './ProfilModal.css';
import { ISearchTrocResidentExtended } from "../../../services/interfaces/ITrocResident2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { badgeIcons } from "../../config/dictionnary/badges";

export function ProfilUserWhenSearchTroc(props: Partial<Pick<ISearchTrocResidentExtended, 'id' | 'pseudo' | 'presentation' | 'number_troc_done' | 'last3Comments' | 'flexible'>> & {
  badges: string[];
}) {
  //destructuring
  const { pseudo, presentation, number_troc_done, last3Comments, flexible, badges } = props;
  
  const [openModal, setOpenModal] = useState(false);

  const [profilR, _setProfilR] = useState<{
    pseudo: string | undefined,
    presentation: string | undefined;
    trocNumber: number | undefined;
    comments: [string | null, string | null, string | null] | null;
    badges: string[] | undefined;
  }>({
    pseudo: pseudo,
    presentation: presentation,
    trocNumber: number_troc_done,
    comments: last3Comments && last3Comments.length > 0 ? [last3Comments[0]?.content || null, last3Comments[1]?.content || null, last3Comments[2]?.content || null] : null,
    badges: badges
  });

  useEffect(() => {
    // Désactiver le défilement quand la modal est ouverte
    if (openModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    // Nettoyage à la fermeture de la modal
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [openModal]);

  return (
    <>
      <button
        id="btn-profil-user"
        type="button"
        className="flex flex-col items-center gap-1 text-center rounded-lg font-semibold w-full text-greenCustom transition hover:text-green-700"
      >
        <div className="hover:underline text-base" onClick={() => setOpenModal(true)}>
          {pseudo}
        </div>

        {flexible && (
          <div
            className="text-xs text-gray-600"
            title="Cet utilisateur est flexible sur les modalités du troc"
          >
            flex <FontAwesomeIcon icon={faCircleCheck} />
          </div>
        )}
      </button>

      {openModal && (
        < div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-2"
          onClick={() => setOpenModal(false)}
        >
          {/* modal section */}
          <div
            className="w-full max-w-2xl bg-white rounded-3xl overflow-y-auto max-h-[90vh] relative"
            onClick={(e) => e.stopPropagation()} // pour ne pas fermer la modale quand on clique à l’intérieur
          >
            {/* header section */}
            <div id="head-modal" className="p-4 bg-gradient-to-r from-yellowCustom via-orangeCustom to-redCustom text-white rounded-t-2xl">
              <h2 className="text-xl font-semibold text-center text-gray-800">
                Profil {pseudo}
              </h2>
            </div>

            <hr className="border-t-2 border-orangeCustom shadow" />

            {/* badges section */}
            {Array.isArray(profilR.badges) && profilR.badges.length > 0 && (
              <div className="flex flex-col items-center w-full mt-2">
                <h4 className="text-sm font-medium text-gray-700">Badges</h4>
                <div className="flex flex-wrap justify-center gap-2 mt-2">
                  {profilR.badges.map((badge, index) => (
                    <div
                      key={index}
                      className="flex items-center gap-1 bg-orangeCustom text-lightRedCustom font-bold px-3 py-1 rounded-full text-xs shadow-sm"
                    >
                      <FontAwesomeIcon icon={badgeIcons[badge]} className="text-sm" />
                      <span>{badge}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* body section */}
            <div className="flex flex-col gap-6 bg-white px-6 py-8">
              {/* presentation section  */}
              <div className="text-center">
                <h3 className="text-lg font-bold mb-2">Présentation :</h3>
                <div className="bg-yellowCustom border border-black rounded-lg px-6 py-4">
                  <p className="text-gray-900">
                    {profilR.presentation || "ne s’est pas encore présenté"}
                  </p>
                </div>
              </div>
            </div>

            {/* troc done section */}
            <div id="trocsNumber" className="flex justify-center">
              <div className="bg-orangeCustom rounded-full text-center px-4 py-2 text-white shadow-md">
                <p className="text-lg font-semibold">{profilR.trocNumber ?? 0} trocs effectués</p>
              </div>
            </div>

            {/* comments section */}
            <div className="w-full pb-4">
              <h3 className="text-lg font-bold text-center mb-4">Commentaires</h3>

              <div id="caroussels-comments" className="h-40 mt-2">
                <Carousel
                  slideInterval={5000}
                  indicators
                  className="relative bg-gray-100 border border-gray-200 rounded-lg p-6 text-center"
                >
                  {profilR.comments && profilR.comments.length > 0 ? (
                    profilR.comments
                      .filter((comment) => comment !== null)
                      .map((comment, index) => (
                        <div key={index} className="flex h-full items-center justify-center">
                          <p className="italic text-gray-700">"{comment}"</p>
                        </div>
                      ))
                  ) : (
                    <p className="text-black">Aucun commentaire</p>
                  )}
                </Carousel>
              </div>
            </div>

            <hr className="border-t-2 border-orangeCustom shadow" />

            {/* footer section */}
            <div
              id="footer-modal-profil"
              className="bg-white border-t flex justify-center p-4 rounded-b-3xl shadow-sm"
            >
              <button
                type="button"
                className="bg-redCustom hover:bg-red-600 transition rounded-md px-6 py-2 text-white font-semibold"
                onClick={() => setOpenModal(false)}
              >
                Fermer
              </button>
            </div>
          </div>
        </div >
      )}
    </>
  );
}
